import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    shouldScroll: {
      type: Boolean,
      default: false,
    },
  };

  connect() {
    if (this.shouldScrollValue) {
      // Use requestAnimationFrame to ensure the element is in the DOM
      requestAnimationFrame(() => {
        this.element.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        // Clear the shouldScroll value to prevent re-scrolling on reconnect
        // (e.g., when Turbo morphs content and Stimulus reconnects controllers)
        this.shouldScrollValue = false;

        // Remove scroll_to from URL while preserving other query parameters
        const url = new URL(window.location.href);
        url.searchParams.delete("scroll_to");
        history.replaceState({}, document.title, url.toString());
      });
    }
  }
}
